'use es6';

import { GROUP_KEYS } from 'getting-started-shared-tasks/gettingStartedGroupKeys';
import { ONBOARDING_VIEWS } from 'user-context/onboardingSettings';
import { HAS_USED_HUBSPOT } from '../constants/queryParamConstants';
import { CRM_SIGNUP } from '../constants/signupConstants';
import { EMAIL_MARKETING_USE_CASE, EXPERIENCE_HAS_USED_CRM_PARAM, EXPERIENCE_HAS_USED_HUBSPOT, EXPERIENCE_NONE_PARAM, MARKETING_HUB_INTEREST, SURVEY_KEYS } from '../constants/surveyConstants';
import { createMarketingOnboardingKey } from '../utils/onboardingKeyUtils';
import { HubletUrl } from '../utils/urls';
import { CRM_USE_CASE_ONBOARDING } from 'getting-started-shared-tasks/onboardingKeys';
const marketingExperiencesChecks = [{
  redirectPath: (portalId, auth, survey) => {
    return {
      url: `${HubletUrl.getAppUrl()}/user-guide/${portalId}`,
      view: ONBOARDING_VIEWS.SUITE,
      onboardingKey: CRM_USE_CASE_ONBOARDING,
      groupKey: GROUP_KEYS[survey[SURVEY_KEYS.USAGE_TYPE]]
    };
  },
  checks: [{
    survey: {
      usageType: EMAIL_MARKETING_USE_CASE
    }
  }]
}, {
  // If the user has used HubSpot before, we want to send them to the Data Management flow.
  redirectPath: portalId => {
    return {
      url: `${HubletUrl.getAppUrl()}/getting-set-up/${portalId}`,
      view: ONBOARDING_VIEWS.MARKETING,
      onboardingKey: createMarketingOnboardingKey(EXPERIENCE_HAS_USED_HUBSPOT),
      groupKey: GROUP_KEYS.marketerSep2020
    };
  },
  checks: [{
    survey: {
      crmExperience: HAS_USED_HUBSPOT,
      hubInterest: MARKETING_HUB_INTEREST
    }
  }]
}, {
  // User with no CRM experience and marketing hub interest and CRM signup type
  redirectPath: portalId => {
    return {
      url: `${HubletUrl.getAppUrl()}/marketing-tour/${portalId}/intro-crm-demo`,
      view: ONBOARDING_VIEWS.MARKETING,
      onboardingKey: createMarketingOnboardingKey(EXPERIENCE_NONE_PARAM),
      groupKey: GROUP_KEYS.INEXPERIENCED_SIMPLIFIED_MARKETING
    };
  },
  redirectParams: {
    crmExperience: EXPERIENCE_NONE_PARAM,
    doNotSetGroupkey: true
  },
  checks: [{
    signupType: CRM_SIGNUP,
    survey: {
      crmExperience: EXPERIENCE_NONE_PARAM,
      hubInterest: MARKETING_HUB_INTEREST
    }
  }]
}, {
  // User with some CRM experience and the marketing hub interest and CRM signup type
  redirectPath: portalId => {
    return {
      url: `${HubletUrl.getAppUrl()}/marketing-tour/${portalId}/intro-crm-demo`,
      view: ONBOARDING_VIEWS.MARKETING,
      onboardingKey: createMarketingOnboardingKey(EXPERIENCE_HAS_USED_CRM_PARAM),
      groupKey: GROUP_KEYS.marketerSep2020
    };
  },
  redirectParams: {
    crmExperience: EXPERIENCE_HAS_USED_CRM_PARAM
  },
  checks: [{
    signupType: CRM_SIGNUP,
    survey: {
      crmExperience: EXPERIENCE_HAS_USED_CRM_PARAM,
      hubInterest: MARKETING_HUB_INTEREST
    }
  }]
}, {
  // User with no CRM experience and marketing hub interest
  redirectPath: portalId => {
    return {
      url: `${HubletUrl.getAppUrl()}/marketing-tour/${portalId}/start-demo`,
      view: ONBOARDING_VIEWS.MARKETING,
      onboardingKey: createMarketingOnboardingKey(EXPERIENCE_NONE_PARAM),
      groupKey: GROUP_KEYS.INEXPERIENCED_SIMPLIFIED_MARKETING
    };
  },
  redirectParams: {
    crmExperience: EXPERIENCE_NONE_PARAM,
    doNotSetGroupkey: true
  },
  checks: [{
    survey: {
      crmExperience: EXPERIENCE_NONE_PARAM,
      hubInterest: MARKETING_HUB_INTEREST
    }
  }]
}, {
  // User with some CRM experience and the marketing hub interest
  redirectPath: portalId => {
    return {
      url: `${HubletUrl.getAppUrl()}/marketing-tour/${portalId}/start-demo`,
      view: ONBOARDING_VIEWS.MARKETING,
      onboardingKey: createMarketingOnboardingKey(EXPERIENCE_HAS_USED_CRM_PARAM),
      groupKey: GROUP_KEYS.marketerSep2020
    };
  },
  redirectParams: {
    crmExperience: EXPERIENCE_HAS_USED_CRM_PARAM
  },
  checks: [{
    survey: {
      crmExperience: EXPERIENCE_HAS_USED_CRM_PARAM,
      hubInterest: MARKETING_HUB_INTEREST
    }
  }]
}];
export default marketingExperiencesChecks;